import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { PerfilService } from '../../services/PerfilService';
import { toast } from 'react-toastify';

const AsignarPermisos = ({ perfilId, perfilName, onClose, token }) => {
  const [permisos, setPermisos] = useState([]);
  const [permisosAsignados, setPermisosAsignados] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const getPermisos = async () => {
      try {
        const response = await PerfilService.getPermisos(token);
        setPermisos(response)
      } catch (err) {
        setError("Error al guardar categoría");
        console.log(err);
      }
    };

    const getPermisosByPerfil = async () => {
      try {
        const response = await PerfilService.getPermisosByPerfil(token, perfilId);

        const idsAsignados = response.map(p => p.permiso_id);

        setPermisosAsignados(idsAsignados)
      } catch (err) {
        setError("Error al guardar categoría");
        console.log(err);
      }
    };

    getPermisos();
    getPermisosByPerfil();
  }, [perfilId, token]);

  const togglePermiso = (permisoId) => {
    setPermisosAsignados(prev =>
      prev.includes(permisoId)
        ? prev.filter(id => id !== permisoId)
        : [...prev, permisoId]
    );
  };

  const guardarPermisos = async () => {
    try {
       await PerfilService.guardarPermisos(token, { permisos: permisosAsignados }, perfilId);
      toast.success("Se asigno los permisos correctamente");
      onClose();
    } catch (err) {
      setError("Error al guardar perfil");
      console.log(err);
    }
  };

  return (
    <div className="modal-overlay"> 
      <div className="modal-box">
        <div className="modal-header">
          <span>Asignar permisos al perfil {perfilName}</span>
          <button className="modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-content">
          <ul className="permisos-list">
            {permisos.map(permiso => (
              <li key={permiso.id} className="permiso-item">
                <label className="permiso-label" htmlFor={`permiso-${permiso.id}`}>
                  <input
                    type="checkbox"
                    id={`permiso-${permiso.id}`}
                    className="checkbox-compact"
                    checked={permisosAsignados.includes(Number(permiso.id))}
                    onChange={() => togglePermiso(permiso.id)}
                    aria-label={permiso.clave}
                  />
                  <div className="permiso-texto">
                    <span className="permiso-clave">{permiso.clave}</span>
                    <span className="permiso-descripcion">{permiso.descripcion}</span>
                  </div>
                </label>
              </li>
            ))}
          </ul>

          {error && <div className="alert alert-danger">{error}</div>}

          <div className="modal-buttons-compact">
            <button onClick={guardarPermisos} className="btn btn-primary-compact">
              Guardar
            </button>
            <button
              type="button"
              className="btn btn-secondary-compact"
              onClick={onClose}
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

AsignarPermisos.propTypes = {
  perfilId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  perfilName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
};

export default AsignarPermisos; 
